import config from "@/config"
import http from "@/utils/request"

export default {
	getVersion: {
		url: `${config.API_URL}/lqa-game/system/version/byprojectNum?projectNum=`,
		name: "获取版本信息",
		get: async function(params){
			return await http.get(this.url+params);
		}
	},
	
}
